import { readableForeground } from './utils';

interface Branding {
  name: string;
  primaryColor: string;
  brandingVersion: string;
  hasFavicon?: boolean;
}

/** Setzt Mandantenfarbe, Titel und Favicon. */
export function applyBranding(b: Branding) {
  const root = document.documentElement;
  root.style.setProperty('--primary', b.primaryColor);
  root.style.setProperty('--primary-foreground', readableForeground(b.primaryColor));
  document.title = b.name;
  const link = document.getElementById('favicon') as HTMLLinkElement | null;
  if (link && b.hasFavicon !== false) {
    link.href = `/api/public/tenant/favicon?v=${b.brandingVersion}`;
  }
}

export function logoUrl(version: string) {
  return `/api/public/tenant/logo?v=${version}`;
}
